import { StoreApiUrl } from "_constants/StoreAPI";
import { GET, POST } from "_helpers/Fetch";

export const StoreApi = {
    RequireVstsBaseSubscription,
    GetVstsFutureSubscription,
    GetVstsActiveSubscription,
    GetVstsSubscriptionPricing,
    GetVsttActiveProducts,
    GetVsttSubscriptionsPricing,
    PlaceOrder
}

async function RequireVstsBaseSubscription() {
    try {
        const response = await GET(StoreApiUrl.VSTS_BASE_SUBSCRIPTION_CHECK)
        return response.data.result.requireBaseSubscription;
    } catch (err) {
        return null;
    }
}

async function GetVstsFutureSubscription() {
    try {
        const response = await GET(StoreApiUrl.VSTS_FUTURE_SUBSCRIPTION_CHECK)
        return response.data.futureSubscription;
    } catch (err) {
        return null;
    }
}

async function GetVstsActiveSubscription() {
    try {
        const response = await GET(StoreApiUrl.VSTS_ACTIVE_SUBSCRIPTION_CHECK)
        return response.data.currentSubscription;
    } catch (err) {
        return null;
    }
}

async function GetVstsSubscriptionPricing(infoId) {
    try {
        var url = StoreApiUrl.VSTS_PRODUCT_PRICING;
        url = url.replace("{0}", infoId);
        const response = await GET(url)
        return response.data
    } catch (err) {
        return null;
    }
}

async function GetVsttActiveProducts(productIds) {
    try {
        var url = StoreApiUrl.VSTT_ACTIVE_PRODUCTS_CHECK + "?";
        productIds.forEach((id) => { url += "productIds=" + id + "&" })
        const response = await GET(url)
        return response.data
    } catch (err) {
        return null;
    }
}

async function GetVsttSubscriptionsPricing(productIds) {
    try {
        var url = StoreApiUrl.VSTT_PRODUCT_PRICING + "?";
        productIds.forEach((id) => {
            url += "productIds=" + id + "&"
        })
        const response = await GET(url)
        return response.data
    } catch (err) {
        return null;
    }
}

async function PlaceOrder(orderList) {
    try {
        const response = await POST(StoreApiUrl.PLACE_ORDER, orderList);
        return response.data
    } catch (err) {
        return null;
    }
}